"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Aug 20 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * RoundingRuleConverter.
 *
 * @author RV
 */


var RoundingRuleConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(RoundingRuleConverter, _DataObjectConverter_);

  function RoundingRuleConverter() {
    _classCallCheck(this, RoundingRuleConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(RoundingRuleConverter).apply(this, arguments));
  }

  return RoundingRuleConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.RoundingRuleConverter = RoundingRuleConverter;